export default __webpack_public_path__ + "static/media/20.49744063.png";